import axios from 'axios';
import { MD5 } from 'crypto-js';
import Base64 from 'crypto-js/enc-base64';

const API_BASE_URL = 'https://cabos.mondula.de/api/'; // Direct API server connection with HTTPS
//const API_KEY = process.env.REACT_APP_API_KEY; // Store your API key in an environment variable
const API_KEY = 'testkey'
const ASSET_URL = 'https://modeldatabase.pss.orendtstudios.com/assets/';
const ASSET_SECRET = '37098bec1a588a94bb51c8a1531a61fe070deea4357562f0f54b1de155d82cad';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${API_KEY}`,
    'Content-Type': 'application/json',
  },
});

export const getModels = async (page, size) => {
  const params = { page, size };
  return api.get('/api/v1/models', { params });
};

export const getModelsSearch = (page, pageSize, searchTerm = '') => {
  return api.get('/api/v1/models/', {
    params: {
      page,
      size: pageSize,
      searchTerm,
    },
  });
};


export const getLatestModels = async (page, size, sort = 'date') => {
  const params = { page, size, sort };
  return api.get('/api/v1/models', { params });
};

export const getModelsSort = async (page, pageSize, sort = 'date', categories = []) => {
  console.log('categories: ' + categories);
  const params = {
    page,
    size: pageSize,
    sort,
    category: categories.join(', '),
  };
  
  return api.get('/api/v1/models/', { params });
};

export const createModel = async (modelData) => {
  return api.post('/api/v1/models', modelData);
};

export const updateModel = async (modelData) => {
  return api.put('/api/v1/models', modelData);
};

export const patchModel = async (id, modelData) => {
  return api.patch(`/api/v1/models/${id}`, modelData);
};

export const getModelById = async (id) => {
  return api.get(`/api/v1/models/${id}`);
};

export const getModelBatchByIds = async (ids) => {
  return api.post('/api/v1/models/batch', {ids});
};

export const deactivateModel = async (id) => {
  return api.post(`/api/v1/models/${id}/deactivate`);
};

export const getCastingForOptions = async () => {
  return api.get('/api/v1/models/casting-for');
};

export const getCastingLocations = async () => {
  return api.get('/api/v1/models/casting-locations');
};

export const getCategories = async () => {
  return api.get('/api/v1/categories/oldcategories');
};

export const getModelDiversity = async (ids) => {
  return api.post('/api/v1/models/diversity', { ids });
};

export const handleDeletedContact = async (personId) => {
  return api.post('/api/v1/models/contact-deleted', { personId });
};

export const getModelStats = async (searchTerm, poolId) => {
  const params = { searchTerm };
  const headers = poolId ? { 'x-pool-id': poolId } : {};
  return api.get('/api/v1/models/stats', { params, headers });
};

export const getModelStatsSearch = async (poolId) => {
  const options = {};
  if (poolId) {
    options.headers = { 'x-pool-id': poolId };
  }
  return api.get('/api/v1/models/stats', options);
};

export const getStatsForSpecificModels = async (ids) => {
  return api.post('/api/v1/models/stats', { ids });
};

export const uploadAsset = async (file, modelId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('modelId', modelId);
  return api.post('/api/v1/models/assets', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getAssetRotation = async (file) => {
  return api.get('/api/v1/models/assets/rotation', { params: { file } });
};

export const scaleAsset = async (file, modelId) => {
  return api.post('/api/v1/models/assets/scale', { file, modelId });
};

export const generateSmallThumbnail = async (file, modelId) => {
  return api.post('/api/v1/models/assets/small-thumbnail', { file, modelId });
};

export const generateLargeThumbnail = async (file, modelId) => {
  return api.post('/api/v1/models/assets/large-thumbnail', { file, modelId });
};

export const rotateAsset = async (file, modelId) => {
  return api.post('/api/v1/models/assets/rotate', { file, modelId });
};
export const getPools = async () => {
  return api.get(`/api/v1/pools`);
};

export const getPoolModels = async (poolId) => {
  return api.get(`/api/v1/pools/${poolId}`);
};

export const getPaginatedPoolModels = async (poolId, page, size, sort, searchTerm, ethnicityFilter) => {
  const params = { page, size, sort, searchTerm, ethnicityFilter };
  return api.get(`/api/v1/pools/${poolId}/models`, { params });
};

export const addModelToPool = async (poolId, modelId) => {
  return api.post(`/api/v1/pools/${poolId}/models/${modelId}/add`);
};

export const removeModelFromPool = async (poolId, modelId) => {
  return api.post(`/api/v1/pools/${poolId}/models/${modelId}/remove`);
};

export const getAssetInlineLink = async (modelId, assetType) => {
  try {
    console.log(`Fetching asset for model ${modelId}, type ${assetType}`);
    const response = await api.get(`/api/v1/models/assets/inline`, {
      params: { modelId, assetType }
    });
    console.log('Asset inline link response received');
    return response.data.inlineLink; // This is now a base64 encoded image
  } catch (error) {
    console.error(`Error fetching asset for model ${modelId}:`, error);
    // ... error handling ...
    return null;
  }
};

export const getDownloadLink = (file, inline = false) => {
  if (!file) return '';

  // Calculate expiration time (approximately 12 hours from now, aligned to ~2.7 hour intervals)
  const expires = Math.floor(Date.now() / 10000000) * 10000 + 3600 * 12;

  const md5 = calculateMD5(file.path, expires);

  const url = new URL(ASSET_URL);
  url.pathname += encodeURIComponent(file.path).replace(/%2F/g, '/');
  url.searchParams.append('md5', md5);
  url.searchParams.append('expires', expires.toString());

  if (file.mimetype) {
    url.searchParams.append('mimeType', file.mimetype);
  }

  if (inline) {
    url.searchParams.append('inline', 'true');
  }

  return url.toString();
};

const calculateMD5 = (path, expires) => {
  const fullPath = new URL(path, ASSET_URL).pathname;
  const data = `${expires}${fullPath} ${ASSET_SECRET}`;

  const md5Hash = MD5(data);
  return Base64.stringify(md5Hash)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const getInlineLink = (file) => getDownloadLink(file, true);

export default api;
